// src/components/AboutPage.jsx
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const currentYear = new Date().getFullYear();
  const APP_VERSION = __APP_VERSION__;

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header 
      <header className="bg-white border-bottom py-3">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <Link to="/" className="text-decoration-none">
                <div className="logo-placeholder">
                  Tt
                </div>
              </Link>
              <div className="ms-3">
                <Link to="/" className="text-decoration-none">
                  <h5 className="mb-0 text-primary fw-bold">TaskIT</h5>
                </Link>
                <small className="text-muted">О нас</small>
              </div>
            </div>
            <div>
              <Link to="/" className="btn btn-link text-decoration-none me-3">
                Главная
              </Link>
              <Link to="/features" className="btn btn-link text-decoration-none me-3">
                Возможности
              </Link>
              <Link to="/login" className="btn btn-outline-primary me-2">
                Войти
              </Link>
              <Link to="/login" className="btn btn-primary">
                Регистрация
              </Link>
            </div>
          </div>
        </Container>
      </header>

      {/* Hero Section *
      <section className="bg-light py-5">
        <Container>
          <Row className="align-items-center py-4">
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-5 fw-bold mb-4">О проекте TaskIT</h1>
              <p className="lead text-muted">
                Современная платформа для управления задачами, созданная для повышения 
                продуктивности команд любого размера.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission Section *
      <section className="py-5">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <h2 className="mb-4">Наша миссия</h2>
              <p className="mb-4">
                Мы стремимся сделать управление задачами простым, интуитивным и эффективным 
                для всех - от небольших стартапов до крупных корпораций.
              </p>
              <div className="d-flex gap-3">
                <div className="text-center">
                  <div className="display-4 fw-bold text-primary">10K+</div>
                  <div className="text-muted">Пользователей</div>
                </div>
                <div className="text-center">
                  <div className="display-4 fw-bold text-primary">500+</div>
                  <div className="text-muted">Команд</div>
                </div>
                <div className="text-center">
                  <div className="display-4 fw-bold text-primary">24/7</div>
                  <div className="text-muted">Поддержка</div>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="p-4 border rounded-3 bg-white shadow-sm">
                <h4 className="mb-3">Наши ценности</h4>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <strong>Простота:</strong> Интуитивный интерфейс без лишних сложностей
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <strong>Надежность:</strong> Стабильная работа 99.9% времени
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <strong>Безопасность:</strong> Защита данных - наш приоритет
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <strong>Инновации:</strong> Постоянное улучшение продукта
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section *
      <section className="bg-light py-5">
        <Container>
          <h2 className="text-center mb-5">Команда разработчиков</h2>
          <Row className="g-4 justify-content-center">
            {[
              { name: 'Алексей Иванов', role: 'Frontend разработчик', desc: 'Специалист по React и UI/UX' },
              { name: 'Мария Петрова', role: 'Backend разработчик', desc: 'Эксперт в FastAPI и базах данных' },
              { name: 'Дмитрий Сидоров', role: 'DevOps инженер', desc: 'Настройка инфраструктуры и CI/CD' },
              { name: 'Екатерина Волкова', role: 'Product менеджер', desc: 'Разработка стратегии продукта' },
            ].map((member, index) => (
              <Col md={6} lg={3} key={index}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="text-center p-4">
                    <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto mb-3"
                      style={{ width: '80px', height: '80px' }}>
                      <i className="bi bi-person fs-3"></i>
                    </div>
                    <h5 className="mb-2">{member.name}</h5>
                    <div className="badge bg-primary bg-opacity-10 text-primary mb-3">
                      {member.role}
                    </div>
                    <p className="text-muted small">{member.desc}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact CTA *
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h2 className="mb-4">Есть вопросы?</h2>
              <p className="lead mb-4">
                Свяжитесь с нашей командой для получения дополнительной информации
              </p>
              <div className="d-flex gap-3 justify-content-center">
                <a href="mailto:support@taskit.com" className="btn btn-primary">
                  <i className="bi bi-envelope me-2"></i>
                  Написать нам
                </a>
                <Link to="/" className="btn btn-outline-primary">
                  На главную
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer *
      <footer className="bg-white border-top py-4 mt-auto">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="logo-placeholder me-3">
                  Tt
                </div>
                <div>
                  <h6 className="mb-0 text-primary fw-bold">TaskIT</h6>
                  <small className="text-muted">© {currentYear} Все права защищены</small>
                </div>
              </div>
            </Col>
            <Col md={6} className="text-end">
              <div className="d-flex justify-content-end gap-3">
                <Link to="/" className="text-muted text-decoration-none small">
                  Главная
                </Link>
                <Link to="/about" className="text-muted text-decoration-none small">
                  О нас
                </Link>
                <Link to="/privacy" className="text-muted text-decoration-none small">
                  Политика конфиденциальности
                </Link>
                <Link to="/terms" className="text-muted text-decoration-none small">
                  Условия использования
                </Link>
              </div>
              <p className="text-muted small mb-0 mt-2">
                HAKSTER | {currentYear} TaskIT<small>.version {APP_VERSION}</small>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
  );*/}
    </div>
  );
};

export default AboutPage;